import { FC, useContext, useEffect } from 'react';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import { CoveragesCivilSection } from '../CoveragesCivilSection';

import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm/StepTwoFormContext';
import { StepThreeFormContext } from '../../contexts/StepThreeForm';

interface CivilQuotationFormByTabProps {
  tabKey: number;
}

export const CivilQuotationFormByTab: FC<CivilQuotationFormByTabProps> = ({
  tabKey,
}) => {
  const { stepThreeCivilQuotationForm } = useContext(StepThreeFormContext);

  const { planOptionsBySelectedPlan, stepTwoForm } =
    useContext(StepTwoFormContext);

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  useEffect(() => {
    if (planSelected) {
      stepThreeCivilQuotationForm.setFieldValue(
        `plan-tab-${tabKey}`,
        planSelected
      );
    }
  }, [planSelected, stepThreeCivilQuotationForm, tabKey]);

  return (
    <>
      <ContentSection level='h3' title='Planes'>
        <RowSize>
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Lista de Planes:',
                name: `plan-tab-${tabKey}`,
              }}
              selectProps={{
                placeholder: 'Seleccionar',
                options: planOptionsBySelectedPlan,
                disabled: true,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>

      <CoveragesCivilSection tabKey={tabKey} />
    </>
  );
};
